if (import.meta.env.DEV) {
	await import('./wdyr');
}

import './index.css';
import SplashScreen from '@pages/pure-loading-screen';
import * as Sentry from '@sentry/react';
import { AuthProvider } from '@shared/auth-provider';
import { COSMOS_PUBLIC_ROUTES } from '@shared/constants/pages';
import '@varadise-ltd/cosmology/styles.css';
import { lazy, StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
const AppWrapper = lazy(() => import('./AppWrapper'));
//const App = lazy(() => import('./AppTest'));

const ENV_PREFIX = import.meta.env.VITE_WEBAPP_ENVIRONMENT_PREFIX
	? `${import.meta.env.VITE_WEBAPP_ENVIRONMENT_PREFIX}-`
	: '';

Sentry.init({
	enabled: !import.meta.env.DEV,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	release: import.meta.env.VITE_WEBAPP_VERSION,
	environment: ENV_PREFIX + import.meta.env.VITE_WEBAPP_ENVIRONMENT,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	// tracePropagationTargets,
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<HelmetProvider>
				<AuthProvider publicRoutes={COSMOS_PUBLIC_ROUTES}>
					<Suspense fallback={<SplashScreen />}>
						<AppWrapper />
					</Suspense>
				</AuthProvider>
			</HelmetProvider>
		</StrictMode>
	);
}
